var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShekelLightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 6.66683V13.3335H12.4993V6.66683C12.4993 4.8285 11.0043 3.3335 9.16601 3.3335H4.16602V16.6668H5.83268V5.00016H9.16601C10.0852 5.00016 10.8327 5.74766 10.8327 6.66683Z",
    fill: "#586A84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.3335C14.1667 14.2527 13.4192 15.0002 12.5 15.0002H9.16667V6.66683H7.5V16.6668H12.5C14.3383 16.6668 15.8333 15.1718 15.8333 13.3335V3.3335H14.1667V13.3335Z",
    fill: "#586A84"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekelLightIcon);
export default __webpack_public_path__ + "static/media/shekel-light-icon.0f5629972de92f64c3e81dad6fde46c6.svg";
export { ForwardRef as ReactComponent };